webpackJsonp([36],{

/***/ "GP+o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledManufacturer = _styledComponents2.default.div.withConfig({
    displayName: 'Manufacturer__StyledManufacturer',
    componentId: 'sc-1k451wm-0'
})(['\n        display: block;\n        font-size: 0.81em;\n        line-height: 1;\n']);

var Text = function Text() {
    return _react2.default.createElement(
        StyledManufacturer,
        null,
        'Hersteller:',
        _react2.default.createElement('br', null),
        'Becker & Karsten UG (haftungsbeschr\xE4nkt)',
        _react2.default.createElement('br', null),
        'Sandhauser Str. 107, 13505 Berlin',
        _react2.default.createElement('br', null),
        'www.stoff.love',
        _react2.default.createElement('br', null),
        'Telefon: +49 30 609851965'
    );
};

exports.default = Text;

/***/ }),

/***/ "HK2s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _fabrics = __webpack_require__("yRPi");

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _Link = __webpack_require__("ImdF");

var _Link2 = _interopRequireDefault(_Link);

var _List = __webpack_require__("mK8I");

var _List2 = _interopRequireDefault(_List);

var _i18n = __webpack_require__("lg9U");

var _Manufacturer = __webpack_require__("GP+o");

var _Manufacturer2 = _interopRequireDefault(_Manufacturer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fabrics = function Fabrics(_ref) {
    var fabrics = _ref.fabrics,
        fabricInfoPrefix = _ref.fabricInfoPrefix;

    var buildSpec = function buildSpec(fabricInfo) {
        var items = [];
        Object.keys(fabricInfo.specification.content).map(function (label, index) {
            items.push(_react2.default.createElement(
                'li',
                { className: 'stolo-list-item', key: index },
                _react2.default.createElement(
                    'span',
                    { className: 'stolo-list-item-label' },
                    label,
                    ': '
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'stolo-list-item-value' },
                    fabricInfo.specification.content[label]
                )
            ));
        });
        return items;
    };

    var buildCareInstructions = function buildCareInstructions(fabricInfo) {
        var items = [];
        fabricInfo['care-instructions'].content.map(function (value, index) {
            items.push(_react2.default.createElement(
                'li',
                { className: 'stolo-list-item', key: index },
                _react2.default.createElement(
                    'span',
                    { className: 'stolo-list-item-value' },
                    value
                )
            ));
        });
        return items;
    };

    var StyledText = _styledComponents2.default.p.withConfig({
        displayName: 'Fabrics__StyledText',
        componentId: 'sc-1sl1nc4-0'
    })(['\n        max-width: ', ';\n        line-height: 1.31;\n        margin-bottom: ', ';\n    '], function (props) {
        return props.theme.space[23];
    }, function (props) {
        return props.theme.space[7];
    });

    var buildFabricInfo = function buildFabricInfo() {
        return Object.keys(fabrics).map(function (fabricId) {
            var fabricInfo = fabrics[fabricId];
            return _react2.default.createElement(
                'div',
                { id: fabricId },
                _react2.default.createElement(_Heading2.default, {
                    level: 1,
                    text: [fabricInfoPrefix, ' ', fabricInfo.title]
                }),
                _react2.default.createElement(
                    StyledText,
                    null,
                    fabricInfo.description.content
                ),
                _react2.default.createElement('img', {
                    src: fabricInfo.description.img,
                    alt: fabricInfo.title
                }),
                _react2.default.createElement(_Heading2.default, { level: 2, text: fabricInfo.usage.label }),
                _react2.default.createElement(
                    StyledText,
                    null,
                    fabricInfo.usage.content
                ),
                _react2.default.createElement('img', {
                    src: fabricInfo.usage.img,
                    alt: fabricInfo.usage.label
                }),
                _react2.default.createElement(_Heading2.default, {
                    level: 2,
                    text: fabricInfo.specification.label
                }),
                _react2.default.createElement(
                    StyledText,
                    null,
                    _react2.default.createElement(
                        'ul',
                        null,
                        buildSpec(fabricInfo)
                    )
                ),
                _react2.default.createElement(_Heading2.default, {
                    level: 2,
                    text: fabricInfo['care-instructions'].label
                }),
                _react2.default.createElement(
                    StyledText,
                    null,
                    _react2.default.createElement(
                        'ul',
                        null,
                        buildCareInstructions(fabricInfo)
                    ),
                    _react2.default.createElement('img', {
                        src: 'https://d2k02hhj0n6fcf.cloudfront.net/images/care-1-2.png',
                        alt: fabricInfo['care-instructions'].label
                    })
                ),
                _react2.default.createElement(_Manufacturer2.default, null)
            );
        });
    };

    var buildIndex = function buildIndex() {
        return Object.keys(fabrics).map(function (fabricId) {
            var fabricInfo = fabrics[fabricId];
            return _react2.default.createElement(
                _Link2.default,
                { to: '#' + fabricId },
                fabricInfo.title
            );
        });
    };

    return _react2.default.createElement(
        'article',
        { role: 'article', about: '/faq/fabrics', 'typeof': 'schema:WebPage' },
        _react2.default.createElement(
            _ContentWrapper2.default,
            null,
            _react2.default.createElement(_List2.default, { items: buildIndex() }),
            buildFabricInfo()
        )
    );
};

var makeMapStateToProps = function makeMapStateToProps(initialState) {
    var fabrics = (0, _fabrics.getFabrics)(initialState);
    var mapStateToProps = function mapStateToProps(state) {
        return {
            fabrics: fabrics,
            fabricInfoPrefix: (0, _i18n.getMessage)(state, 'FABRIC_INFO_TITLE')
        };
    };
    return mapStateToProps;
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(Fabrics);

/***/ }),

/***/ "ImdF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _StyledLink = __webpack_require__("K4Q2");

var _StyledLink2 = _interopRequireDefault(_StyledLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Link = function Link(_ref) {
    var title = _ref.title,
        to = _ref.to,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ['title', 'to', 'children']);

    return _react2.default.createElement(
        _StyledLink2.default,
        _extends({
            title: title,
            href: to || '#' }, props),
        children
    );
};

exports.default = Link;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "xAT9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Fabrics = __webpack_require__("HK2s");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Fabrics).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/Fabrics.96a18094f243ed670bbb.js